export const contactInfoBaseClasses: string = 'grid grid-cols-[40%_60%] gap-y-2'
export const cardColumnBaseClasses: string = 'flex w-full md:w-1/2'
